import styled from 'styled-components';

export const RowContainer = styled.div`
  display: flex;
  margin: ${(props) => props.margin && props.margin} !important;
  height: ${(props) => props.height && props.height};
`;
